import {GET_FLAG_NOTI_FINE_REG, SET_FLAG_READ_NOTIFICATION, SET_STD_KEY_FINE_REG_NOTI_READ} from '../actionTypes'



// export const addKeyToFineRegNoti = key => ({
//     type: SET_STD_KEY_FINE_REG_NOTI_READ, 
//     payload: key
// })

export const addKeyToFineRegNoti = key => dispatch => {
    // let notifications = localStorage.getItem("notifications")
    // if (!notifications) {
    //     notifications = {}
    //     notifications.notiFineRegs = []
    //     let item = { [key]: '0' }
    //     notifications.notiFineRegs.push(item)
    //     localStorage.setItem("notifications", notifications)
    // }
    // console.log("addKey", key)

    dispatch({
        type: SET_STD_KEY_FINE_REG_NOTI_READ,
        // payload: notifications
    })
}

export const getFlagNotiFineReg = () => ({
    type: GET_FLAG_NOTI_FINE_REG
})
